import { GetThemeMode, SetThemeToDark, SetThemeToLight } from "../../core/Metronic";
import { setDarkMode, useGlobal } from "../../core/Global";
import Icon from "./Icon";
import "./ThemeToggle.css";


// Light/dark switch for the pages that sit outside the console. Sign-in and sign-up have no
// header, so the toggle in the user menu is out of reach until someone is already logged in —
// which is exactly when a dark-theme user does not want a white page.
//
// It writes the same stored choice the user menu does, so a preference set here survives into
// the console and back again.
export default function ThemeToggle() {

    const [globalState] = useGlobal();
    const dark = globalState.darkMode ?? (GetThemeMode() === "dark");

    const toggle = () => {
        const next = !dark;
        if (next) SetThemeToDark();
        else SetThemeToLight();
        setDarkMode(next);
    };

    const label = dark ? "Switch to light mode" : "Switch to dark mode";

    return (
        <button type="button" className="theme-toggle" onClick={toggle} title={label} aria-label={label}>
            <Icon icon={dark ? "sun-bright" : "moon"} type="solid" size={15} />
        </button>
    );
}
